<template>
  <div class="flex">
    <div class="relative flex items-center justify-center h-full w-full">
      <img
        :src="DefaultBOGXBadgeImage "
        class="h-full w-auto block"
      >
      <div class="absolute rotate-[-24deg] top-1/2 left-1/2 translate-x-[calc(-50%)] translate-y-[calc(-40%)] w-full overflow-visible">
        <span class="black-stroke-golden-text badge-text uppercase font-[800] text-[10px] leading-3 whitespace-pre-line w-full overflow-visible inline-block h-max text-center">{{ saleName }}</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import DefaultBOGXBadgeImage from '@/assets/images/periodic/default-BOGX/default-BOGX-badge.png'
import { useShop } from '@/composables/game/shop'

const { saleName } = useShop()
</script>
<style lang="scss" scoped>
@import '@/assets/styles/sales';

</style>